import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import Logo from '../../components/Logo';

const AdminVerifyOtp = () => {
  const { verifyOtp, pendingEmail, isAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (isAuthenticated()) return <Navigate to="/admin" replace />;
  if (!pendingEmail) return <Navigate to="/admin/login" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const res = await verifyOtp(otp.trim());
    setSubmitting(false);
    if (res.success) {
      navigate('/admin');
    } else {
      setError(res.error || 'Verification failed');
    }
  };

  return (
    <div className="admin-auth-page">
      <nav className="admin-auth-nav">
        <div className="admin-auth-nav-inner">
          <div className="admin-brand">
            <Logo height={30} />
          </div>
          <button
            type="button"
            className="admin-auth-nav-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}
            onClick={() => navigate('/admin/login')}
          >
            ← Back to login
          </button>
        </div>
      </nav>

      <div className="admin-auth-wrap">
        <div className="admin-auth-card">
          <h1>Enter verification code</h1>
          <p className="admin-auth-sub">
            We sent a 6-digit code to <strong style={{ color: '#f0f0f2' }}>{pendingEmail}</strong>. It expires in 10 minutes.
          </p>
          <form onSubmit={handleSubmit}>
            <label>Code</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
              autoComplete="one-time-code"
              autoFocus
              required
              className="admin-otp-input"
            />
            {error && <div className="admin-auth-error">{error}</div>}
            <button type="submit" disabled={submitting || otp.length !== 6}>
              {submitting ? 'Verifying…' : 'Verify & sign in'}
            </button>
          </form>
          <button
            type="button"
            className="admin-auth-link"
            onClick={() => navigate('/admin/login')}
          >
            Use a different account
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminVerifyOtp;
